// import { Icon } from '@iconify/react/dist/iconify.js'
// import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
// import { api } from '../helper/api.interceptor'
// import { auto } from '@popperjs/core'

// const SignInLayer = () => {
//     const [showPassword, setShowPassword] = useState(false);
//     const [remember, setRemember] = useState(false);
//     const handleCheckboxChange = () => {
//         setRemember(!remember);
//     };
//     const [formData, setFormData] = useState({ username: '', password: '' })
//     const handleLogIn = async (e) => {
//         e.preventDefault()
//         const { username, password } = formData
//         const resp = await api.signIn({ username, password })
//     }

//     //static email password
//     // const [email, setEmail] = useState("");
//     // const [password, setPassword] = useState("");

//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     if (!email || !password) {
//     //         alert("Please enter email and password");
//     //         return;
//     //     }

//     //     const success = email === "test@example.com" && password === "password123";

//     //     if (success) {
//     //         const fakeToken = "your-auth-token";
//     //         sessionStorage.setItem("token", fakeToken);
//     //         window.location.href = "/";
//     //     } else {
//     //         alert("Invalid credentials");
//     //     }
//     // };
//     return (
//         <section className="auth bg-base d-flex flex-wrap">
//             <div className="auth-left d-lg-block d-none">
//                 <div className="d-flex align-items-center flex-column h-100 justify-content-center">
//                     <img src="assets/images/sign-in-page-kalp.webp" alt="sign-in-img" width='100%' height="100%" style={{ minHeight: "100vh", objectFit: "cover" }} />
//                 </div>
//             </div>
//             <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
//                 <div className="max-w-464-px mx-auto w-100">
//                     <div>
//                         <Link to="/sign-in" className="mb-40 max-w-290-px">
//                             <img src="assets/images/kapil-logo.png" alt="" width={200} height={auto} />
//                         </Link>
//                         <h4 className="mb-12">Sign In to your Account</h4>
//                         <p className="mb-32 text-secondary-light text-lg">
//                             Welcome back! please enter your detail
//                         </p>
//                     </div>
//                     <form onSubmit={handleSubmit}>
//                         <div className="icon-field mb-16">
//                             <span className="icon top-50 translate-middle-y">
//                                 <Icon icon="mage:email" />
//                             </span>
//                             <input
//                                 type="email"
//                                 className="form-control h-56-px bg-neutral-50 radius-12"
//                                 placeholder="Email"
//                                 value={email}
//                                 onChange={(e) => setEmail(e.target.value)}
//                             />
//                         </div>
//                         <div className="position-relative mb-20">
//                             <div className="icon-field">
//                                 <span className="icon top-50 translate-middle-y">
//                                     <Icon icon="solar:lock-password-outline" />
//                                 </span>
//                                 <input
//                                     type="password"
//                                     className="form-control h-56-px bg-neutral-50 radius-12"
//                                     id="your-password"
//                                     placeholder="Password"
//                                     value={password} onChange={(e) => setPassword(e.target.value)}
//                                 />
//                             </div>
//                             <span
//                                 className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
//                                 data-toggle="#your-password"
//                             />
//                         </div>

//                         {/* <div className="position-relative mb-20">
//                             <div className="icon-field">
//                                 <span className="icon top-50 translate-middle-y">
//                                     <Icon icon="solar:lock-password-outline" />
//                                 </span>
//                                 <input
//                                     type="password"
//                                     className="form-control h-56-px bg-neutral-50 radius-12"
//                                     id="your-password"
//                                     placeholder="Password"
//                                     value={password} onChange={(e) => setPassword(e.target.value)}
//                                 />
//                             </div>
//                             <span
//                                 className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
//                                 onClick={() => setShowPassword((prev) => !prev)}
//                             >
//                                 <Icon icon={showPassword ? "ri-eye-off-line" : "ri-eye-line"} />
//                             </span>
//                         </div> */}
//                         <div>
//                             <div className="d-flex justify-content-between gap-2">
//                                 <div className="form-check style-check d-flex align-items-center">
//                                     <input
//                                         className="form-check-input border border-neutral-300"
//                                         type="checkbox"
//                                         id="remember"

//                                     />
//                                     <label className="form-check-label" htmlFor="remember">
//                                         Remember me
//                                     </label>
//                                 </div>
//                                 {/* <Link to="#" className="text-primary-600 fw-medium">
//                     Forgot Password?
//                 </Link> */}
//                             </div>
//                         </div>
//                         <button
//                             type="submit"
//                             className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
//                         >
//                             {" "}
//                             Sign In
//                         </button>
//                         {/* <div className="mt-32 center-border-horizontal text-center">
//                             <span className="bg-base z-1 px-4">Or sign in with</span>
//                         </div> */}
//                         {/* <div className="mt-32 d-flex align-items-center gap-3">
//                             <button
//                                 type="button"
//                                 className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
//                             >
//                                 <Icon
//                                     icon="ic:baseline-facebook"
//                                     className="text-primary-600 text-xl line-height-1"
//                                 />
//                                 Google
//                             </button>
//                             <button
//                                 type="button"
//                                 className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
//                             >
//                                 <Icon
//                                     icon="logos:google-icon"
//                                     className="text-primary-600 text-xl line-height-1"
//                                 />
//                                 Google
//                             </button>
//                         </div> */}
//                         {/* <div className="mt-32 text-center text-sm">
//                             <p className="mb-0">
//                                 Don’t have an account?{" "}
//                                 <Link to="/sign-up" className="text-primary-600 fw-semibold">
//                                     Sign Up
//                                 </Link>
//                             </p>
//                         </div> */}
//                     </form>
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default SignInLayer







import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../helper/api.interceptor';


const SignInLayer = ({ setSession }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [passwordVisible, setPasswordVisible] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Object.values(formData).every(item => item.toString().trim().length > 0)) {
            if (true) {
                await api.signIn(formData).then(dt => {

                    if (dt?.token) {
                        // sessionStorage.setItem('userId', JSON.stringify(dt?.result?.admin_id))
                        // console.log('setSession: ', setSession);
                        setSession(dt?.token);
                        setTimeout(() => {
                            navigate('/');
                        }, 0);
                    } else {
                        alert("Invalid Credentials");
                    }
                })

            } else {
                alert('Invalid user');
            }
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(prevState => !prevState);
    };
    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="assets/images/sign-in-page-kalp.webp" alt="sign-in-img" width='100%' height="100%" style={{ minHeight: "100vh", objectFit: "cover" }} />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <Link to="/sign-in" className="mb-40 max-w-290-px">
                            <img src="assets/images/kapil-logo.png.png" alt="" width={200} />
                        </Link>
                        <h4 className="mb-12">Sign In to your Account</h4>
                        <p className="mb-32 text-secondary-light text-lg">
                            Welcome back! please enter your detail
                        </p>
                    </div>
                    <form action="#" onSubmit={handleSubmit}>
                        <div className="icon-field mb-16">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="email"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>
                        {/* <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type="password"
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    id="your-password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={(e) => setFormData((prev) => { return { ...prev, password: e.target.value } })}
                                />
                            </div>
                            <span
                                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                data-toggle="#your-password"
                            />
                        </div> */}

                        <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={passwordVisible ? 'text' : 'password'} // Toggle between text and password type
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    id="your-password"
                                    placeholder="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>
                            <span
                                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                onClick={togglePasswordVisibility} // Toggle password visibility when clicked
                            />
                        </div>
                        <div>
                            <div className="d-flex justify-content-between gap-2">
                                <div className="form-check style-check d-flex align-items-center">
                                    {/* <input
                                        className="form-check-input border border-neutral-300"
                                        type="checkbox"
                                        id="remember"
                                        checked={remember}
                                        onChange={handleCheckboxChange}
                                    />
                                    <label className="form-check-label" htmlFor="remember">
                                        Remember me
                                    </label> */}
                                </div>
                                {/* <Link to="#" className="text-primary-600 fw-medium">
                    Forgot Password?
                </Link> */}
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                        >
                            {" "}
                            Sign In
                        </button>
                        {/* <div className="mt-32 center-border-horizontal text-center">
                            <span className="bg-base z-1 px-4">Or sign in with</span>
                        </div> */}
                        {/* <div className="mt-32 d-flex align-items-center gap-3">
                            <button
                                type="button"
                                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                            >
                                <Icon
                                    icon="ic:baseline-facebook"
                                    className="text-primary-600 text-xl line-height-1"
                                />
                                Google
                            </button>
                            <button
                                type="button"
                                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                            >
                                <Icon
                                    icon="logos:google-icon"
                                    className="text-primary-600 text-xl line-height-1"
                                />
                                Google
                            </button>
                        </div> */}
                        {/* <div className="mt-32 text-center text-sm">
                            <p className="mb-0">
                                Don’t have an account?{" "}
                                <Link to="/sign-up" className="text-primary-600 fw-semibold">
                                    Sign Up
                                </Link>
                            </p>
                        </div> */}
                    </form>
                </div>
            </div>
        </section>

    )
}

export default SignInLayer